import React from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TranscriptionPage from './TranscriptionPage';

const NotesTranscriptionPage: React.FC = () => {
  const navigate = useNavigate();
  const [tab, setTab] = React.useState<'notes'|'trans'>('trans');
  const onChangeTab = (_: any, value: 'notes'|'trans') => {
    setTab(value);
    if (value === 'notes') navigate('/app/notes');
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 64px)', mt: '64px' }}>
      <Box sx={{ px: 3, pt: 2, pb: 1, borderBottom: '1px solid #eee', backgroundColor: '#fff' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>Notatki ze spotkań</Typography>
        <Tabs value={tab} onChange={onChangeTab} sx={{ minHeight: 36 }} TabIndicatorProps={{ sx: { height: 2 } }}>
          <Tab label="Notatki" value="notes" sx={{ minHeight: 36 }} />
          <Tab label="Transkrypcje" value="trans" sx={{ minHeight: 36 }} />
        </Tabs>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <TranscriptionPage />
      </Box>
    </Box>
  );
};

export default NotesTranscriptionPage;


